import axios from "axios";
import { API_BASE_URL } from "../../config";
import AsyncStorage from "@react-native-async-storage/async-storage";

export const fetchUCEventsPN = async (eventId, userId) => {
  try {
    const token = await AsyncStorage.getItem("wfcm"); // safely get token from storage

    const params = {
      Event_ID: eventId,
      User_ID: userId,
    };

    // Only include Token if it exists
    if (token) {
      params.Token = token;
    }

    const response = await axios.get(`${API_BASE_URL}/User/home.php`, {
      params,
    });

    console.log(response.data);
    return response.data;
  } catch (error) {
    // console.error("Error fetching events:", error);
    throw error;
  }
};
